var levelOfAWSUsage = {
	"Level of AWS usage": "Nível de uso da AWS",
	"Do not use AWS today": "Ainda não usa a AWS",
	"Evaluating/experimenting with AWS": "Avaliando/experimentando a AWS",
	"Run dev/test workloads on AWS": "Executa cargas de trabalho de desenvolvimento/teste na AWS",
	"Run a production workload on AWS": "Executa uma única workload de produção na AWS",
	"Run multiple production workloads on AWS": "Executa várias workloads de produção na AWS"
};

export { levelOfAWSUsage as default };
